import { NavLink } from 'react-router-dom';
import { BrandLockup } from '@/components/BrandMark/BrandMark';
import { Button } from '@/components/Button/Button';
import { isAdmin, usePrincipal } from '@/features/auth/identity';
import type { Theme } from '@/lib/hooks/useTheme';
import styles from './TopBar.module.scss';

interface TopBarProps {
  theme: Theme;
  onToggleTheme: () => void;
}

export function TopBar({ theme, onToggleTheme }: TopBarProps) {
  const principal = usePrincipal();

  return (
    <header className={styles.topbar}>
      <NavLink to="/" className={styles.brand} aria-label="Alpantos Academy home">
        <BrandLockup />
      </NavLink>

      <nav className={styles.nav} aria-label="Primary">
        <NavLink to="/" end className={({ isActive }) => (isActive ? styles.active : styles.link)}>
          Workshop
        </NavLink>
        {/* Cosmetic gating only — /admin/* is enforced server-side (BR-AP1). */}
        {isAdmin(principal) && (
          <NavLink to="/admin" className={({ isActive }) => (isActive ? styles.active : styles.link)}>
            Admin
          </NavLink>
        )}
      </nav>

      <div className={styles.account}>
        <span className={styles.identity}>{principal?.identity ?? 'Guest'}</span>
        <Button
          size="sm"
          variant="ghost"
          onClick={onToggleTheme}
          aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
        >
          {theme === 'dark' ? 'Light' : 'Dark'}
        </Button>
      </div>
    </header>
  );
}
